import { render, staticRenderFns } from "./Convite.vue?vue&type=template&id=4a3830fe&"
import script from "./Convite.vue?vue&type=script&lang=js&"
export * from "./Convite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports